import React, { useState } from 'react';
import { simpanEntri, senaraiVersi, pulihVersi, binaDataEntri, borangDari, masa } from '../services/promptArchV2Service';

// ═══════════════════════════════════════════════════════════
//  PROMPT ARCHITECTURE V2 — tab Prompt Library
//  Sunting 8 pustaka prompt: Global Master · Category Playbooks · Story Formulas ·
//  Presentation Styles · Creative Presets · Scene Planner · Video Model Adapters · Output Contract.
//
//  Borang dibina daripada TAKRIF yang dihantar server (`lib.jenis`) — medan baharu ditambah
//  di functions/promptArchV2Teras.js sahaja, tiada salinan di sini.
//  Setiap Save = versi baharu (server menyemak versi asas; suntingan serentak ditolak dengan
//  mesej jelas). Restore menulis versi lama sebagai versi BAHARU — sejarah tidak dipadam.
//  Tiada butang padam: entri yang tidak dipakai di-Archive (masih boleh dipulihkan).
// ═══════════════════════════════════════════════════════════

const KELAS_INPUT = 'w-full h-9 px-3 text-[13.5px] border border-slate-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-indigo-500';
const KELAS_AREA = 'w-full px-3 py-2 text-[13px] leading-relaxed border border-slate-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-indigo-500 resize-y';
const KELAS_LABEL = 'block text-[12px] font-semibold text-slate-500 mb-1';
const BAHARU = '__baharu__';

function Medan({ m, nilai, onUbah, lib }) {
  const barisTeks = (s) => Math.min(14, Math.max(3, Math.ceil(String(s || '').length / 110) + String(s || '').split('\n').length));
  let kawalan;
  if (m.jenis === 'perenggan') {
    kawalan = <textarea value={nilai} onChange={(e) => onUbah(e.target.value)} rows={barisTeks(nilai)} className={KELAS_AREA} />;
  } else if (m.jenis === 'senarai') {
    kawalan = <textarea value={nilai} onChange={(e) => onUbah(e.target.value)} rows={Math.max(3, String(nilai || '').split('\n').length + 1)} placeholder="Satu baris = satu item" className={KELAS_AREA} />;
  } else if (m.jenis === 'nombor') {
    kawalan = <input type="number" min={m.min} max={m.maks} value={nilai} onChange={(e) => onUbah(e.target.value)} className={KELAS_INPUT + ' max-w-[160px]'} />;
  } else if (m.jenis === 'rujuk') {
    const pilihan = (lib.pustaka[m.rujuk] || []).filter((e) => !e.diarkib || e.id === nilai);
    kawalan = (
      <select value={nilai} onChange={(e) => onUbah(e.target.value)} className={KELAS_INPUT}>
        <option value="">(pilih)</option>
        {pilihan.map((e) => <option key={e.id} value={e.id}>{e.nama}{!e.aktif ? ' (disabled)' : ''}</option>)}
      </select>
    );
  } else if (m.jenis === 'rujukBanyak') {
    const dipilih = Array.isArray(nilai) ? nilai : [];
    const pilihan = (lib.pustaka[m.rujuk] || []).filter((e) => !e.diarkib || dipilih.includes(e.id));
    kawalan = (
      <div className="flex flex-wrap gap-1.5">
        {pilihan.map((e) => {
          const ada = dipilih.includes(e.id);
          return (
            <button
              key={e.id}
              onClick={() => onUbah(ada ? dipilih.filter((x) => x !== e.id) : [...dipilih, e.id])}
              className={`px-2.5 py-1 text-[12px] rounded-lg border ${ada ? 'bg-indigo-600 text-white border-indigo-600 font-semibold' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`}
            >{e.nama}</button>
          );
        })}
      </div>
    );
  } else {
    // teks · url · senaraiNombor
    kawalan = <input value={nilai} onChange={(e) => onUbah(e.target.value)} placeholder={m.jenis === 'url' ? 'https://…' : ''} className={KELAS_INPUT} />;
  }
  return (
    <div>
      <label className={KELAS_LABEL}>{m.label}{m.wajib ? ' *' : ''}</label>
      {kawalan}
      {m.bantu && <p className="text-[11.5px] text-slate-400 m-0 mt-1">{m.bantu}</p>}
    </div>
  );
}

export default function ArchV2Pustaka({ lib, onMuatSemula }) {
  const mulaJenis = lib.susunan[0];
  const [jenis, setJenis] = useState(mulaJenis);
  const [idPilih, setIdPilih] = useState(() => (lib.jenis[mulaJenis].tunggal ? lib.idTunggal : null));
  const [borang, setBorang] = useState(() => {
    const def = lib.jenis[mulaJenis];
    return def.tunggal ? borangDari(def, lib.pustaka[mulaJenis].find((e) => e.id === lib.idTunggal)) : null;
  });
  const [asal, setAsal] = useState(() => JSON.stringify(borang));
  // Versi entri SEMASA borang dimuat — dihantar sebagai versi asas. Kalau pustaka dimuat semula
  // dan entri sudah lebih baharu, server menolak Save (bukan menindih suntingan orang lain).
  const [versiBorang, setVersiBorang] = useState(() => (lib.jenis[mulaJenis].tunggal ? (lib.pustaka[mulaJenis].find((e) => e.id === lib.idTunggal)?.versi ?? null) : null));
  const [tunjukArkib, setTunjukArkib] = useState(false);
  const [sedang, setSedang] = useState(false);
  const [mesej, setMesej] = useState(null); // { jenis: 'ok' | 'ralat', teks }
  const [versi, setVersi] = useState({ buka: false, sedang: false, senarai: [], ralat: null });

  const def = lib.jenis[jenis];
  const senarai = lib.pustaka[jenis] || [];
  const entri = idPilih && idPilih !== BAHARU ? senarai.find((e) => e.id === idPilih) || null : null;
  const kotor = borang != null && JSON.stringify(borang) !== asal;
  const baharu = idPilih === BAHARU;

  const bolehTinggal = () => !kotor || window.confirm('Suntingan belum disimpan akan hilang. Teruskan?');

  const muatKeBorang = (j, id, sumber) => {
    const d = sumber.jenis[j];
    const e = (sumber.pustaka[j] || []).find((x) => x.id === id) || null;
    const b = e ? borangDari(d, e) : null;
    setJenis(j);
    setIdPilih(e ? id : null);
    setBorang(b);
    setAsal(JSON.stringify(b));
    setVersiBorang(e ? e.versi : null);
    setVersi({ buka: false, sedang: false, senarai: [], ralat: null });
  };

  const pilihJenis = (j) => {
    if (j === jenis || !bolehTinggal()) return;
    setMesej(null);
    if (lib.jenis[j].tunggal) muatKeBorang(j, lib.idTunggal, lib);
    else muatKeBorang(j, null, lib);
  };
  const pilihEntri = (id) => {
    if (id === idPilih || !bolehTinggal()) return;
    setMesej(null);
    muatKeBorang(jenis, id, lib);
  };
  const mulaBaharu = (salinan) => {
    if (!bolehTinggal()) return;
    const b = salinan ? { ...salinan, nama: `${salinan.nama} (copy)`, aktif: true, diarkib: false } : borangDari(def, null);
    setIdPilih(BAHARU);
    setBorang(b);
    setAsal('');
    setVersiBorang(null);
    setMesej(null);
    setVersi({ buka: false, sedang: false, senarai: [], ralat: null });
  };

  const simpan = async () => {
    if (sedang || !borang) return;
    setSedang(true);
    setMesej(null);
    let r;
    try {
      r = await simpanEntri({ jenis, id: baharu ? '' : idPilih, data: binaDataEntri(def, borang), versiAsas: versiBorang, baharu });
    } catch (e) {
      setMesej({ jenis: 'ralat', teks: 'TIDAK disimpan — ' + (e?.message || String(e)) });
      setSedang(false);
      return;
    }
    const libBaru = await onMuatSemula();
    if (libBaru) {
      muatKeBorang(jenis, r.id, libBaru);
      setMesej({ jenis: 'ok', teks: r.tiadaPerubahan ? 'Tiada perubahan — tiada versi baharu dicipta.' : `Disimpan sebagai versi ${r.versi}.` });
    } else {
      setMesej({ jenis: 'ralat', teks: `Disimpan (versi ${r.versi}), tetapi pustaka gagal dimuat semula — tekan Reload di atas sebelum menyunting lagi.` });
    }
    setSedang(false);
  };

  const bukaVersi = async () => {
    if (versi.buka) { setVersi((v) => ({ ...v, buka: false })); return; }
    setVersi({ buka: true, sedang: true, senarai: [], ralat: null });
    try {
      const r = await senaraiVersi({ jenis, id: idPilih });
      setVersi({ buka: true, sedang: false, senarai: r.senarai || [], ralat: null });
    } catch (e) {
      setVersi({ buka: true, sedang: false, senarai: [], ralat: e?.message || String(e) });
    }
  };
  const pulih = async (v) => {
    if (sedang || !entri) return;
    if (!window.confirm(`Pulihkan versi ${v.versi}? Ia akan ditulis sebagai versi baharu (v${entri.versi + 1}); versi lain kekal dalam sejarah.`)) return;
    setSedang(true);
    setMesej(null);
    try {
      const r = await pulihVersi({ jenis, id: idPilih, versi: v.versi, versiAsas: entri.versi });
      const libBaru = await onMuatSemula();
      if (libBaru) muatKeBorang(jenis, idPilih, libBaru);
      setMesej(r.tiadaPerubahan
        ? { jenis: 'ok', teks: `Versi ${v.versi} sama dengan isi semasa — tiada perubahan.` }
        : { jenis: 'ok', teks: `Versi ${v.versi} dipulihkan sebagai versi ${r.versi}.` });
    } catch (e) {
      setMesej({ jenis: 'ralat', teks: 'TIDAK dipulihkan — ' + (e?.message || String(e)) });
    } finally {
      setSedang(false);
    }
  };

  const ubah = (k, v) => {
    setBorang((b) => ({ ...b, [k]: v }));
    // Mesej "Disimpan…" lama dibuang sebaik admin menyunting semula, supaya peringatan
    // "ada suntingan belum disimpan" tidak terlindung. Mesej RALAT kekal sehingga Save seterusnya.
    setMesej((m) => (m?.jenis === 'ok' ? null : m));
  };
  const dipapar = senarai.filter((e) => tunjukArkib || !e.diarkib || e.id === idPilih);
  const bilArkib = senarai.filter((e) => e.diarkib).length;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[190px_250px_1fr] gap-3 items-start">
      {/* Jenis pustaka */}
      <div className="rounded-xl bg-white border border-slate-200 p-2">
        {lib.susunan.map((j) => (
          <button
            key={j}
            onClick={() => pilihJenis(j)}
            className={`w-full text-left px-3 py-2 rounded-lg text-[13px] ${j === jenis ? 'bg-indigo-50 text-indigo-700 font-bold' : 'text-slate-600 hover:bg-slate-50'}`}
          >
            <span className="text-[11px] font-bold text-slate-400 mr-1.5">{lib.jenis[j].lapisan}</span>{lib.jenis[j].label}
            {!lib.jenis[j].tunggal && <span className="text-[11px] text-slate-400 ml-1">({(lib.pustaka[j] || []).filter((e) => !e.diarkib).length})</span>}
          </button>
        ))}
      </div>

      {/* Senarai entri */}
      <div className="rounded-xl bg-white border border-slate-200 p-2">
        {def.tunggal ? (
          <p className="text-[12.5px] text-slate-500 leading-relaxed m-0 px-2 py-2">{def.label} hanya ada satu entri. {def.skop}</p>
        ) : (
          <>
            <button onClick={() => mulaBaharu(null)} className="w-full h-9 flex items-center justify-center gap-1.5 text-[13px] font-bold text-indigo-600 border border-dashed border-indigo-300 rounded-lg hover:bg-indigo-50 mb-1.5">
              <span className="material-symbols-outlined text-[16px]">add</span>New
            </button>
            {baharu && <div className="px-3 py-2 rounded-lg bg-indigo-50 text-[13px] font-bold text-indigo-700 mb-1">(entri baharu — belum disimpan)</div>}
            {dipapar.map((e) => (
              <button
                key={e.id}
                onClick={() => pilihEntri(e.id)}
                className={`w-full text-left px-3 py-2 rounded-lg ${e.id === idPilih ? 'bg-indigo-50' : 'hover:bg-slate-50'}`}
              >
                <p className={`text-[13px] m-0 truncate ${e.id === idPilih ? 'font-bold text-indigo-700' : 'font-semibold text-slate-700'} ${e.diarkib ? 'line-through' : ''}`}>{e.nama}</p>
                <p className="text-[11px] text-slate-400 m-0 mt-0.5">
                  v{e.versi} · {e.sumber === 'benih' ? 'default' : 'edited'}
                  {!e.aktif && <span className="ml-1 text-amber-600 font-semibold">· disabled</span>}
                  {e.diarkib && <span className="ml-1 text-rose-500 font-semibold">· archived</span>}
                </p>
              </button>
            ))}
            {bilArkib > 0 && (
              <button onClick={() => setTunjukArkib((v) => !v)} className="w-full text-left px-3 py-2 text-[12px] text-slate-400 hover:underline">
                {tunjukArkib ? 'Sorok' : 'Tunjuk'} {bilArkib} yang diarkib
              </button>
            )}
          </>
        )}
      </div>

      {/* Editor */}
      <div className="rounded-xl bg-white border border-slate-200 p-5 min-w-0">
        {!borang ? (
          <p className="text-[13px] text-slate-500 m-0">Pilih satu entri di sebelah kiri, atau tekan New.</p>
        ) : (
          <>
            <div className="flex items-start justify-between gap-3 flex-wrap mb-3">
              <div className="min-w-0">
                <p className="text-[15px] font-semibold text-slate-800 m-0">{baharu ? `New — ${def.label}` : (entri?.nama || def.label)}</p>
                <p className="text-[11.5px] text-slate-400 m-0 mt-0.5">
                  {baharu ? 'Id dijana semasa Save.' : (
                    <>id <span className="font-mono">{idPilih}</span> · v{entri?.versi} · {entri?.sumber === 'benih' ? 'default (belum pernah disunting)' : `edited${entri?.updatedAt ? ' ' + masa(entri.updatedAt) : ''}${entri?.updatedBy ? ' oleh ' + entri.updatedBy : ''}`}</>
                  )}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                {!baharu && !def.tunggal && (
                  <button onClick={() => mulaBaharu(borang)} disabled={sedang} className="h-8 px-3 text-[12px] font-semibold text-slate-600 border border-slate-200 rounded-lg hover:bg-slate-50 disabled:opacity-40">Duplicate</button>
                )}
                {!baharu && (
                  <button onClick={bukaVersi} disabled={sedang} className="h-8 px-3 text-[12px] font-semibold text-slate-600 border border-slate-200 rounded-lg hover:bg-slate-50 disabled:opacity-40">{versi.buka ? 'Tutup versions' : 'Versions'}</button>
                )}
                <button onClick={simpan} disabled={sedang || !kotor} className="h-8 px-4 text-[12.5px] font-bold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 disabled:opacity-40 disabled:cursor-not-allowed">
                  {sedang ? 'Menyimpan…' : (baharu ? 'Save (cipta)' : 'Save (versi baharu)')}
                </button>
              </div>
            </div>

            {mesej && (
              <div className={`mb-3 rounded-lg px-3 py-2.5 text-[12.5px] border ${mesej.jenis === 'ok' ? 'bg-emerald-50 border-emerald-200 text-emerald-700' : 'bg-rose-50 border-rose-200 text-rose-700'}`}>{mesej.teks}</div>
            )}
            {kotor && !mesej && <p className="text-[12px] text-amber-700 m-0 mb-3">Ada suntingan belum disimpan.</p>}
            {!baharu && entri && versiBorang != null && entri.versi !== versiBorang && (
              <p className="text-[12px] text-rose-600 m-0 mb-3">Entri ini sudah dikemas kini di tempat lain (kini v{entri.versi}); borang ini masih v{versiBorang}. Save akan ditolak — pilih entri lain kemudian pilih semula entri ini untuk memuat isi terbaru.</p>
            )}

            {versi.buka && (
              <div className="mb-4 rounded-lg bg-slate-50 px-3.5 py-3">
                <p className="text-[12px] font-bold uppercase tracking-wide text-slate-400 m-0 mb-1.5">Version history</p>
                {versi.sedang && <p className="text-[12.5px] text-slate-500 m-0">Memuatkan…</p>}
                {versi.ralat && <p className="text-[12.5px] text-rose-600 m-0">Gagal memuat versi: {versi.ralat}</p>}
                {versi.senarai.map((v) => (
                  <div key={v.versi} className="flex items-center justify-between gap-3 py-1.5 border-b border-slate-200 last:border-0 flex-wrap">
                    <p className="text-[12.5px] text-slate-600 m-0">
                      <b className="text-slate-800">v{v.versi}</b>{v.versi === entri?.versi ? ' (semasa)' : ''} · {v.savedBy === 'benih' ? 'default asal' : `${masa(v.savedAt)} · ${v.savedBy || '—'}`}
                      {v.dipulihDari ? ` · dipulih dari v${v.dipulihDari}` : ''}
                    </p>
                    <div className="flex gap-3">
                      <button onClick={() => { setBorang(borangDari(def, v)); setMesej({ jenis: 'ok', teks: `Isi versi ${v.versi} dimuat ke editor — belum disimpan. Semak, kemudian tekan Save.` }); }} className="text-[12px] font-semibold text-indigo-600 hover:underline">Muat ke editor</button>
                      {v.versi !== entri?.versi && <button onClick={() => pulih(v)} disabled={sedang} className="text-[12px] font-semibold text-indigo-600 hover:underline disabled:opacity-40">Restore</button>}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="space-y-3.5">
              <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-3 items-end">
                <div>
                  <label className={KELAS_LABEL}>Name *</label>
                  <input value={borang.nama} onChange={(e) => ubah('nama', e.target.value)} maxLength={lib.had.entri.nama} className={KELAS_INPUT} />
                </div>
                {!def.tunggal && (
                  <div className="flex items-center gap-4 h-9">
                    <label className="flex items-center gap-1.5 text-[12.5px] text-slate-600 cursor-pointer">
                      <input type="checkbox" checked={borang.aktif} onChange={(e) => ubah('aktif', e.target.checked)} />Enabled
                    </label>
                    <label className="flex items-center gap-1.5 text-[12.5px] text-slate-600 cursor-pointer">
                      <input type="checkbox" checked={borang.diarkib} onChange={(e) => ubah('diarkib', e.target.checked)} />Archived
                    </label>
                  </div>
                )}
              </div>
              <div>
                <label className={KELAS_LABEL}>Description (nota untuk admin — tidak dihantar kepada AI)</label>
                <textarea value={borang.penerangan} onChange={(e) => ubah('penerangan', e.target.value)} rows={2} maxLength={lib.had.entri.penerangan} className={KELAS_AREA} />
              </div>
              {def.medan.map((m) => (
                <Medan key={m.k} m={m} nilai={borang[m.k]} onUbah={(v) => ubah(m.k, v)} lib={lib} />
              ))}
            </div>
            <p className="text-[11.5px] text-slate-400 leading-relaxed m-0 mt-4">
              Skop lapisan ini: {def.skop} Arahan ditulis dalam English (bahasa arahan untuk AI); apa yang penonton dengar/baca diarah dalam Bahasa Melayu Malaysia.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
